import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    "name": "purchaseordertype",
    standalone: true
})
export class PurchaseOrderTypePipe implements PipeTransform {
    transform (value: number): string {
        switch (value) {
            case 1:
                return "House WIP";
            case 2:
                return "Overhead";
            case 3:
                return "Backcharge";
            default:
                return "";
        }
    }
}
